import { FaInstagram, FaFacebook, FaLinkedin, FaTiktok, FaYoutube } from "react-icons/fa6";

export const CANALI = [
  { value: "instagram", label: "Instagram", icon: FaInstagram, color: "#E1306C" },
  { value: "facebook", label: "Facebook", icon: FaFacebook, color: "#1877F2" },
  { value: "linkedin", label: "LinkedIn", icon: FaLinkedin, color: "#0A66C2" },
  { value: "tiktok", label: "TikTok", icon: FaTiktok, color: "#111111" },
  { value: "youtube", label: "YouTube", icon: FaYoutube, color: "#FF0000" },
];
export const canaleOf = (v) => CANALI.find((c) => c.value === v) || CANALI[0];

export const FORMATI = [
  { value: "post", label: "Post" },
  { value: "carosello", label: "Carosello" },
  { value: "reel", label: "Reel / Video" },
  { value: "story", label: "Story" },
  { value: "short", label: "Short" },
];
export const formatoLabel = (v) => FORMATI.find((f) => f.value === v)?.label || v;

export const STATI_POST = [
  { value: "bozza", label: "Bozza", color: "#94A3B8", cls: "bg-slate-100 text-slate-600 border-slate-200" },
  { value: "in_revisione", label: "In revisione", color: "#F59E0B", cls: "bg-amber-50 text-amber-700 border-amber-200" },
  { value: "approvato", label: "Approvato", color: "#2B9BE8", cls: "bg-[#A6DAFC] text-[#0B6BB0] border-[#7CC6FA]" },
  { value: "pubblicato", label: "Pubblicato", color: "#10B981", cls: "bg-emerald-50 text-emerald-700 border-emerald-200" },
];
export const statoPostOf = (v) => STATI_POST.find((s) => s.value === v) || STATI_POST[0];

export const TONI = [
  { value: "professionale", label: "Professionale" },
  { value: "amichevole", label: "Amichevole" },
  { value: "ironico", label: "Ironico" },
  { value: "ispirazionale", label: "Ispirazionale" },
];
